import React from 'react';
import EventCardSkeleton from './EventCardSkeleton';
import { EventsList } from './styles';

type EventListSkeletonProps = {
    ariaLabel?: string;
    dataAuto?: string;
};

const EventListSkeleton: React.FC<EventListSkeletonProps> = ({
    ariaLabel,
    dataAuto,
}) => {
    return (
        <EventsList
            aria-label={ariaLabel}
            data-auto={dataAuto}
            // disable page list global styles
            className='defaultList'
        >
            <EventCardSkeleton />
            <EventCardSkeleton />
        </EventsList>
    );
};

export default EventListSkeleton;
